import { render, staticRenderFns } from "./HelpDocumentation.vue?vue&type=template&id=461a51ed&scoped=true"
import script from "./HelpDocumentation.vue?vue&type=script&lang=js"
export * from "./HelpDocumentation.vue?vue&type=script&lang=js"
import style0 from "./HelpDocumentation.vue?vue&type=style&index=0&id=461a51ed&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461a51ed",
  null
  
)

export default component.exports